import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store'

Vue.use(VueRouter)

const routes = [
    // {
    //     path: '/',
    //     name: 'home',
    //     component: () => import('../views/Home.vue'),
    //     meta: { title: '首页'}
    // },
    {
        path: '/',
        name: 'myclass',
        component: () => import('../views/JcclClass/index.vue'),
        meta: { title: '班级', params: 'qq', login_auth:true}
    },
    {
        path: '/login',
        name: 'home',
        component: () => import('../views/Login.vue'),
        meta: { title: '首页'}
    },
    {
        path: '/leveltest',
        name: 'leveltest',
        component: () => import('../views/Leveltest.vue'),
        meta: { title: '水平测试', params: ''}
    },
    {
        path: '/homeworkanswer',
        name: 'homeworkanswer',
        component: () => import('../views/HomeworkAnswer.vue'),
        meta: { title: '开始测试', params: '',login_auth:true},
        
    },
    {
        path: '/viewreport',
        name: 'viewreport',
        component: () => import('../views/viewreport.vue'),
        meta: { title: '报告',  params: '', login_auth:true},
    },
    {
        path: '/yearslist',
        name: 'yearslist',
        component: () => import('../views/TrueQuestions/YearsList.vue'),
        meta: { title: '历年真题', params: 'qq'}
    },
    {
        path: '/realworklist',
        name: 'realworklist',
        component: () => import('../views/TrueQuestions/WorkList.vue'),
        meta: { title: '历年真题', params: 'qq', login_auth:true}
    },
    {
        path: '/myclass',
        name: 'myclass',
        component: () => import('../views/JcclClass/index.vue'),
        meta: { title: '班级', params: 'qq', login_auth:true}
    },
    {
        path: '/active',
        name: 'active',
        component: () => import('../views/Active/index.vue'),
        meta: { title: '活动', params: 'qq', login_auth:true}
    },
    {
        path: '/signup',
        name: 'signup',
        component: () => import('../views/Active/signup.vue'),
        meta: { title: '报名', params: 'qq', login_auth:true}
    },
    {
        path: '/active/activeshow',
        name: 'activeshow',
        component: () => import('../views/Active/show.vue'),
        meta: { title: '活动详情', params: 'qq', login_auth:true}
    },
    {
        path: '/active/answer',
        name: 'answer',
        component: () => import('../views/Active/answer.vue'),
        meta: { title: '开始答题', params: 'qq', login_auth:true}
    },
    {
        path: '/active/rank',
        name: 'rank',
        component: () => import('../views/Active/rank.vue'),
        meta: { title: '排行榜', params: 'qq', login_auth:true}
    },
   
    {
        path: '/examination',
        name: 'examination',
        component: () => import('../views/Examination/index.vue'),
        meta: { title: '考试中心', params: 'qq', login_auth:true}
    },
    {
        path: '/homework',
        name: 'homework',
        component: () => import('../views/Homework/index.vue'),
        meta: { title: '课后作业', params: 'qq', login_auth:true}
    },
    {
        path: '/exercise',
        name: 'exercise',
        component: () => import('../views/Homework/exercise.vue'),
        meta: { title: '课后练习', params: 'qq', login_auth:true}
    },
    {
        path: '/classsource',
        name: 'homework',
        component: () => import('../views/ClassSource/index.vue'),
        meta: { title: '课后作业', params: 'qq', login_auth:true}
    },
    {
        path: '/userinfo',
        name: 'userinfo',
        component: () => import('../views/User/index.vue'),
        meta: { title: '我的', params: 'qq', login_auth:true}
    },
    {
        path: '/category/:cate',
        name: 'category',
        component: () => import('../views/Home.vue'),
        meta: { title: '分类', params: 'cate'}
    },

]

// history
const router = new VueRouter({
    mode: 'hash',
    base: process.env.BASE_URL,
    routes
})


function checkLoginType(){
    return new Promise((resolve, reject) => {

        var checkLoginInterVal = setInterval(function(){
            var i = 1;
            if(i > 0){
                var guid = store.state.user.guid
                var loginType = store.state.user.loginType
                
                if(guid != '-1' && guid != undefined && guid != "")
                {
                    resolve(true)
                    clearInterval(checkLoginInterVal);
                }
                else
                {
                    if(loginType === false)
                    {
                        resolve(false)
                        clearInterval(checkLoginInterVal);
                    }

                }
                
            }
            i--;
        }, 500);
      
    })
}

function checkRouteMargin(to)
{
    console.log(to)

    var route = to.path
    const match = route.match(/\/([^/]+)\/[^/]+/);
    if(match){
        var route = '/' + match[1]
    }

    store.dispatch('common/setNowRoute', route);
    if(to.path == "/")
    {
        store.dispatch('common/setHeaderMargin', false);
    }
    else
    {
        store.dispatch('common/setHeaderMargin', true);
    }

}


router.beforeEach((to, from, next) => {
    
    let title = '今川日语'
    if (to.meta.params){
        title = `${to.meta.title}:${to.params[to.meta.params] || ''} - ${title}`
    }else {
        title = `${to.meta.title} - ${title}`
    }
    document.title = title

    var guid = store.state.user.guid

    if(to.meta.login_auth)
    {
        
        if(guid == '-1' || guid == '' || guid == undefined)
        {

            router.push({path:'/login'})
            return
            store.dispatch('user/setLoginType', true);
        }
        checkLoginType().then(val => {
            if(val)
            {
                //页面跳转设置loading
                if(to.path != "/")
                {
                    
                    store.dispatch('user/setLoading', true);
                }
                else
                {
                    router.push({path:'/myclass'})
                }
                checkRouteMargin(to)
                next();
            }
            else{
                return;
            }

        });
    }
    else
    {
        //页面跳转设置loading
        if(to.path != "/")
        {
            store.dispatch('user/setLoading', true);
        }
 

        checkRouteMargin(to)
        next();
    }

})
router.afterEach((to, from) => {
    //最多延迟 关闭 loading
    setTimeout(() => {
        store.dispatch('user/setLoading', false);
    }, 1500)
})
export default router
